import React from "react";


export default function PopupArticle(props){
    const closeModal =()=>{
        props.setShowModal(false);
    }
    const modalContent = {
        background: "white",
        padding: "20px 15px",
        borderRadius: "15px",
      };
    
      const overlay = {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
    
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      };

      const line2 = () =>{
        if(props.content2){
            return <p>{props.content2}</p>
        }else{
        }
      }
    return(
        <>
        {props.showFlag ? (
            <div id="overlay" style={overlay}>
                <div className="modalContent" style={modalContent}>
                    <h1>{props.title}</h1>
                    <p>{props.date}</p>
                    {props.component}
                    <p>{props.content}</p>
                    {line2()}
                    <button onClick={closeModal}>Close</button>
                </div>
            </div>
        ) : (
            <></>
        )}
        </>
    )
}
